<template>
  <div>
    <!--  جزییات کارکرد روزانه  -->
    <box title="جزییات کارکرد روزانه">
      <div slot="top-action-view">
        <div class="d-flex">
          <v-btn small icon dark @click="onClickNextDay"
            ><v-icon>mdi-chevron-right</v-icon></v-btn
          >
          <span class="mx-1">{{ inputDate }}</span>
          <v-btn small icon dark @click="onClickPerviusDay"
            ><v-icon>mdi-chevron-left</v-icon></v-btn
          >
        </div>
      </div>
      <div class="d-flex">
        <v-tabs show-arrows>
          <v-tabs-slider color="accent"></v-tabs-slider>

          <v-tab class="text-caption" :href="'#tab_io'">
            <span class="font-sahel">ورود و خروج ها</span>
          </v-tab>

          <v-tab class="text-caption" :href="'#tab_leave'">
            <span class="font-sahel"> مرخصی ها</span>
          </v-tab>

          <v-tab class="text-caption" :href="'#tab_mission'">
            <span class="font-sahel">ماموریت ها</span>
          </v-tab>

          <v-tab-item value="tab_io">
            <DayWorkDetailsTabIO :perno="inputPerno" :date="inputDate" />
          </v-tab-item>

          <v-tab-item value="tab_leave">
            <div class="">
              <day-work-details-tab-leave
                :perno="inputPerno"
                :date="inputDate"
              />
            </div>
          </v-tab-item>

          <v-tab-item value="tab_mission">
            <div class="">
              <day-work-details-tab-mission
                :perno="inputPerno"
                :date="inputDate"
              />
            </div>
          </v-tab-item>
        </v-tabs>
      </div>
    </box>

    <!--  جزییات اطلاعات روزانه  -->
    <box
      class="mt-2"
      :title="`<span>جزییات اطلاعات روزانه</span>
            <span class='px-1'>${person.PersonName}</span>`"
    >
      <div class="pa-3">
        <v-row>
          <v-col cols="12" sm="6">
            <span class="functionality-header">حضور کاری :</span>
            <span class="text-value px-1">{{
              ConvertMinuteToHour(details.WWORK)
            }}</span>
          </v-col>
          <v-col cols="12" sm="6">
            <span class="functionality-header">میزان شب کاری :</span>
            <span class="text-value px-1">{{
              ConvertMinuteToHour(details.NIGHTWORK)
            }}</span>
          </v-col>
          <v-col cols="12" sm="6">
            <span class="functionality-header">کارکرد کل :</span>
            <span class="text-value px-1">{{
              ConvertMinuteToHour(details.WORKTOTAL)
            }}</span>
          </v-col>
          <v-col cols="12" sm="6">
            <span class="functionality-header">تقویم کاری :</span>
            <span class="text-value px-1">{{ details.calName }}</span>
          </v-col>
          <v-col cols="12" sm="6">
            <span class="functionality-header">تعجیل مجاز اول :</span>
            <span class="text-value px-1">{{
              ConvertMinuteToHour(details.EARLYPERMFIRST)
            }}</span>
          </v-col>
          <v-col cols="12" sm="6">
            <span class="functionality-header">تعجیل مجاز دوم :</span>
            <span class="text-value px-1">{{
              ConvertMinuteToHour(details.EARLYPERMLAST)
            }}</span>
          </v-col>
          <v-col cols="12" sm="6">
            <span class="functionality-header">تاخیر مجاز اول :</span>
            <span class="text-value px-1">{{
              ConvertMinuteToHour(details.LATEPERMFIRST)
            }}</span>
          </v-col>
          <v-col cols="12" sm="6">
            <span class="functionality-header">تاخیر مجاز دوم :</span>
            <span class="text-value px-1">{{
              ConvertMinuteToHour(details.LATEPERMLAST)
            }}</span>
          </v-col>
          <v-col cols="12" sm="6">
            <span class="functionality-header">تاخیر سرویس:</span>
            <span class="text-value px-1">{{
              ConvertMinuteToHour(details.SERVICELATE)
            }}</span>
          </v-col>
        </v-row>
      </div>
    </box>

    <!--  جزییات کسر کار -->
    <box class="mt-2" title="جزییات کسر کار">
      <div class="pa-3">
        <v-row>
          <v-col cols="12" sm="6">
            <span class="functionality-header">تعجیل اول :</span>
            <span class="text-value px-1">{{
              ConvertMinuteToHour(details.NW_EARLY_FIRST)
            }}</span>
          </v-col>
          <v-col cols="12" sm="6">
            <span class="functionality-header">تعجیل آخر :</span>
            <span class="text-value px-1">{{
              ConvertMinuteToHour(details.NW_EARLY_LAST)
            }}</span>
          </v-col>
          <v-col cols="12" sm="6">
            <span class="functionality-header">تاخیر اول :</span>
            <span class="text-value px-1">{{
              ConvertMinuteToHour(details.NW_LATE_FIRST)
            }}</span>
          </v-col>
          <v-col cols="12" sm="6">
            <span class="functionality-header">تاخیر آخر :</span>
            <span class="text-value px-1">{{
              ConvertMinuteToHour(details.NW_LATE_LAST)
            }}</span>
          </v-col>
          <v-col cols="12" sm="6">
            <span class="functionality-header">خروج غیر مجاز :</span>
            <span class="text-value px-1">{{
              ConvertMinuteToHour(details.NW_LEAVENOTPERM)
            }}</span>
          </v-col>
          <v-col cols="12" sm="6">
            <span class="functionality-header">غیبت :</span>
            <span class="text-value px-1">{{
              ConvertMinuteToHour(details.NW_ABSENT)
            }}</span>
          </v-col>
          <v-col cols="12" sm="6">
            <span class="functionality-header">کسر کار ویژه :</span>
            <span class="text-value px-1">{{
              ConvertMinuteToHour(details.NW_SPECIAL)
            }}</span>
          </v-col>
        </v-row>
      </div>
    </box>

    <!--  جزییات اضافه کار  -->
    <box class="mt-2" title="جزییات اضافه کار">
      <div class="pa-3">
        <v-row>
          <v-col cols="12" sm="6">
            <span class="functionality-header">اضافه کار در ماموریت :</span>
            <span class="text-value px-1">{{
              ConvertMinuteToHour(details.EW_INMISSION)
            }}</span>
          </v-col>
          <v-col cols="12" sm="6"></v-col>
          <v-col cols="12" sm="6">
            <span class="functionality-header">اضافه کار غیر مجاز تعطیل :</span>
            <span class="text-value px-1">{{
              ConvertMinuteToHour(details.EW_HOLINOTPERM)
            }}</span>
          </v-col>
          <v-col cols="12" sm="6">
            <span class="functionality-header">اضافه کار مجاز تعطیل :</span>
            <span class="text-value px-1">{{
              ConvertMinuteToHour(details.EW_HOLIPERM)
            }}</span>
          </v-col>
          <v-col cols="12" sm="6">
            <span class="functionality-header">اضافه کار عادی غیر مجاز :</span>
            <span class="text-value px-1">{{
              ConvertMinuteToHour(details.EW_NORMNOTPERM)
            }}</span>
          </v-col>
          <v-col cols="12" sm="6">
            <span class="functionality-header">اضافه کار عادی مجاز :</span>
            <span class="text-value px-1">{{
              ConvertMinuteToHour(details.EW_NORMPERM)
            }}</span>
          </v-col>
          <v-col cols="12" sm="6">
            <span class="functionality-header"
              >اضافه کار تعطیل در ماموریت:</span
            >
            <span class="text-value px-1">{{
              ConvertMinuteToHour(details.EW_HoliInMission)
            }}</span>
          </v-col>
          <v-col cols="12" sm="6">
            <span class="functionality-header"
              >اضافه کار غیر تعطیل در ماموریت:</span
            >
            <span class="text-value px-1">{{
              ConvertMinuteToHour(details.EW_NormInMission)
            }}</span>
          </v-col>
          <v-col cols="12" sm="6">
            <span class="functionality-header"
              >اضافه کار غیر مجاز در وقفه:</span
            >
            <span class="text-value px-1">{{
              ConvertMinuteToHour(details.EW_BreakNotPerm)
            }}</span>
          </v-col>
          <v-col cols="12" sm="6">
            <span class="functionality-header">اضافه کار مجاز در وقفه :</span>
            <span class="text-value px-1">{{
              ConvertMinuteToHour(details.EW_BreakPerm)
            }}</span>
          </v-col>
          <v-col cols="12" sm="6">
            <span class="functionality-header">اضافه کار ویژه :</span>
            <span class="text-value px-1">{{
              ConvertMinuteToHour(details.EW_SPECIAL)
            }}</span>
          </v-col>
          <v-col cols="12" sm="6">
            <span class="functionality-header">کل اضافه کار :</span>
            <span class="text-value px-1">{{
              ConvertMinuteToHour(details.EXTRAWORKTOTAL)
            }}</span>
          </v-col>
          <v-col cols="12" sm="6">
            <span class="functionality-header">کل اضافه کار مجاز :</span>
            <span class="text-value px-1">{{
              ConvertMinuteToHour(details.EW_HOLIPERM)
            }}</span>
          </v-col>
          <v-col cols="12" sm="6">
            <span class="functionality-header">کل اضافه کار غیر مجاز :</span>
            <span class="text-value px-1">{{
              ConvertMinuteToHour(details.EW_HOLINOTPERM)
            }}</span>
          </v-col>
        </v-row>
      </div>
    </box>

    <!--  جزییات مرخصی  -->
    <box class="mt-2" title="جزییات مرخصی ">
      <div class="pa-3">
        <v-row>
          <v-col cols="12" sm="6">
            <span class="functionality-header">حضور در مرخصی روزانه :</span>
            <span class="text-value px-1">{{
              ConvertMinuteToHour(details.PRESENCEINDMOR)
            }}</span>
          </v-col>
          <v-col cols="12" sm="6">
            <span class="functionality-header">کل مرخصی :</span>
            <span class="text-value px-1">{{
              ConvertMinuteToHour(details.LEAVEOFABSPAY)
            }}</span>
          </v-col>
          <v-col cols="12" sm="6">
            <span class="functionality-header">مرخصی بدون حقوق :</span>
            <span class="text-value px-1">{{
              ConvertMinuteToHour(details.LEAVEOFABSNOPAY)
            }}</span>
          </v-col>
          <v-col cols="12" sm="6">
            <span class="functionality-header">مرخصی با حقوق :</span>
            <span class="text-value px-1">{{
              ConvertMinuteToHour(details.LEAVEOFABSPAY)
            }}</span>
          </v-col>
        </v-row>
      </div>
    </box>
  </div>
</template>

<script>
import DayWorkDetailsTabIO from "../../components/functionality/daily/DayWorkDetailsTabIO.vue";
import DayWorkDetailsTabLeave from "../../components/functionality/daily/DayWorkDetailsTabLeave.vue";
import DayWorkDetailsTabMission from "../../components/functionality/daily/DayWorkDetailsTabMission.vue";
import ResultType from "../../model/ResultType";
import TextUtils from "../../utils/TextUtils";

export default {
  components: {
    DayWorkDetailsTabIO,
    DayWorkDetailsTabLeave,
    DayWorkDetailsTabMission,
  },
  data() {
    return {
      inputPerno: "",
      inputDate: "",
      person: {},
      details: {},
    };
  },
  mounted() {
    this.pageLoad();
  },
  methods: {
    pageLoad() {
      this.inputPerno = this.$route.query.pid;
      this.inputDate = this.$route.query.DT;
      this.person = this.$store.state.personel.personelDetail;
      this.GetPersonDayWorksDetail();
      console.log(this.inputDate);
    },
    GetPersonDayWorksDetail() {
      this.$store
        .dispatch("GetPersonDayWorksDetail", {
          params: {
            perno: this.inputPerno,
            date: this.inputDate,
          },
        })
        .then((result) => {
          if (result.type === ResultType.success) {
            if (result.data.Table.length > 0) {
              this.details = result.data.Table[0];
            }
          }
        });
    },
    onClickNextDay() {
      console.log(this.$route.path);
      var moment = require("jalali-moment");

      var nextDate = moment(this.inputDate, "jYYYY/jMM/jDD")
        .locale("fa")
        .add(1, "days")
        .format("YYYY/MM/DD");
      //console.log(nextDate);

      var query = {
        pid: this.inputPerno,
        DT: TextUtils.convertToEnglishDigits(nextDate.toString().trim()),
      };

      this.$router.push({ path: this.$route.path, query: query });
      Object.assign(this.$route.query, query);
      //console.log(this.$route.query);
      this.pageLoad();
    },
    onClickPerviusDay() {
      var moment = require("jalali-moment");

      var perviusDate = moment(this.inputDate, "jYYYY/jMM/jDD")
        .locale("fa")
        .subtract(1, "days")
        .format("YYYY/MM/DD");
      //console.log(perviusDate);

      var query = {
        pid: this.inputPerno,
        DT: TextUtils.convertToEnglishDigits(perviusDate.toString().trim()),
      };

      this.$router.push({ path: this.$route.path, query: query });
      Object.assign(this.$route.query, query);
      //console.log(this.$route.query);
      this.pageLoad();
    },
  },
};
</script>

<style>
.functionality-header {
  width: 150px;
  max-width: 150px;
}
</style>